import BodyView from "./BodyView";

export default BodyView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/BodyView/index.js